import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRefuseArrowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={19}
    fill="none"
    viewBox="0 0 19 19"
    style={{ rotate: '180deg' }}
    {...props}
  >
    <path
      fill="#DD1818"
      d="m3.225 3.465.111-.129a1.15 1.15 0 0 1 1.494-.111l.128.111L9.5 7.877l4.542-4.541a1.147 1.147 0 0 1 1.622 1.622L11.123 9.5l4.541 4.542c.407.407.444 1.044.111 1.493l-.111.129a1.15 1.15 0 0 1-1.493.111l-.13-.111L9.5 11.123l-4.542 4.541a1.147 1.147 0 1 1-1.622-1.622L7.877 9.5 3.336 4.958a1.15 1.15 0 0 1-.111-1.493"
    />
    <path
      stroke="#DD1818"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M3.33 6.961h6.334V4.122a.792.792 0 0 1 1.351-.56l5.214 5.214a.79.79 0 0 1 0 1.12l-5.214 5.214a.791.791 0 0 1-1.35-.56V11.71H3.33a.79.79 0 0 1-.792-.792V7.753a.79.79 0 0 1 .792-.792"
    />
  </svg>
);
export default SvgRefuseArrowIcon;
